import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-admin-group-managers-confirmation-dialog',
  templateUrl: './admin-group-managers-confirmation-dialog.component.html',
})
export class AdminGroupManagersConfirmationDialogComponent  implements OnInit {

  @Input() data: any; 
  @Output() remove = new EventEmitter<any>();

  isLoading = true;
  
  ngOnInit(): void {
    this.isLoading = false;
  }

  closeModal() {
    this.remove.emit(null);
  }

  save() {
    this.remove.emit(true);
  }
}
